module.exports = __webpack_public_path__ + "static/media/anotherLogo.215bfd8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/anotherLogo.png
// module id = 50
// module chunks = 0